import { Image } from '@/components/Image'
import { Typography } from '@/components/Typography'
import styles from './InfoBoxInline.module.scss'

export type WidgetInfoboxProps = {
  readonly items: Array<{
    readonly id: string
    readonly model: {
      readonly image?: {
        readonly baseUrl: string
        readonly crop: string
        readonly filename: string
        readonly heightRatio: number
      }
      readonly imageAttributes?: {
        readonly credit?: string
      }
      readonly fields: {
        readonly title: string
        readonly body: string
      }
    }
  }>
}

const InfoBoxInline = ({ item }: { item: WidgetInfoboxProps }) => {
  const image = item.items[0].model.image
  const credit = item.items[0].model.imageAttributes?.credit
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{item.items[0]?.model.fields.title}</h3>
      {item.items.map((item) => (
        <div className={styles.infobox} key={item.id}>
          <div
            className={styles.body}
            dangerouslySetInnerHTML={{
              __html: item.model.fields.body,
            }}
          />

          {image && (
            <figure className={styles.figure}>
              <Image className={styles.image} image={image} defaultWidth={475} alt={image.filename} />
              <figcaption>{credit && <span className={styles.credit}>Foto: {credit}</span>}</figcaption>
            </figure>
          )}
        </div>
      ))}
    </div>
  )
}

export default InfoBoxInline
